<template>
  <v-container fluid class="fill-height background-gradient">
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="6" lg="4">
        <v-card
            elevation="6"
            class="login-card"
            rounded="lg"
        >
          <v-card-title class="text-center pt-5 pb-2">
            <span class="text-h5 font-weight-medium primary--text">Login</span>
          </v-card-title>

          <v-card-text class="pa-5">
            <v-alert
                v-if="error"
                type="error"
                text
                dense
                class="mb-4"
            >
              {{ error }}
            </v-alert>

            <v-form @submit.prevent="fazerLogin">
              <v-text-field
                  v-model="username"
                  label="Usuário"
                  outlined
                  rounded
                  prepend-inner-icon="mdi-account"
                  clearable
                  color="primary"
                  class="login-field"
                  background-color="grey lighten-5"
                  required
              ></v-text-field>

              <v-text-field
                  v-model="password"
                  label="Senha"
                  outlined
                  rounded
                  prepend-inner-icon="mdi-lock"
                  type="password"
                  color="primary"
                  class="login-field"
                  background-color="grey lighten-5"
                  required
                  @keyup.enter="fazerLogin"
              ></v-text-field>

              <v-btn
                  block
                  color="primary"
                  rounded
                  elevation="2"
                  height="45"
                  class="mt-6 text-capitalize font-weight-medium white--text"
                  @click="fazerLogin"
                  :loading="loading"
              >
                <v-icon left>mdi-login</v-icon>
                {{ loading ? 'Entrando...' : 'Entrar' }}
              </v-btn>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import authService from '@/services/authService';

export default {
  name: 'LoginPage',
  data() {
    return {
      username: '',
      password: '',
      loading: false,
      error: null
    };
  },
  mounted() {
    if (authService.isAuthenticated()) {
      this.$router.push('/');
    }
  },
  methods: {
    async fazerLogin() {
      if (!this.username || !this.password) {
        this.error = 'Preencha todos os campos';
        return;
      }

      this.loading = true;
      this.error = null;

      try {
        const success = await authService.login(this.username, this.password);

        if (success) {
          const redirectPath = this.$route.query.redirect || '/';
          this.$router.push(redirectPath);
        } else {
          this.error = 'Credenciais inválidas. Por favor, tente novamente.';
        }
      } catch (error) {
        this.error = 'Ocorreu um erro durante o login. Por favor, tente novamente.';
        console.error('Erro no login:', error);
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.background-gradient {
  background: linear-gradient(135deg, #f8f9fa 0%, #f0e9eb 100%);
}

.login-card {
  border-radius: 20px !important;
  transition: all 0.3s ease;
  border: 1px solid rgba(255, 255, 255, 0.7);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.07) !important;
}

.login-field {
  border-radius: 12px;
}

.v-text-field >>> .v-input__slot {
  min-height: 56px;
}

.v-btn {
  letter-spacing: 0.5px;
  text-transform: none;
  transition: all 0.2s ease;
}

.v-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.1) !important;
}

/* Sutis detalhes de vinho/bordô na interface */
.v-card:hover {
  box-shadow: 0 12px 24px rgba(86, 22, 49, 0.09) !important;
}
</style>